import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import YTable from '@/views/components/table/index.vue';
import { listCorp } from '@/api/corp.js';
export default {
  name: 'base-corp-index',
  components: {
    YTable: YTable
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    return {
      dataLoading: false,
      dataList: [],
      searchForm: {
        address: null,
        contactPerson: null,
        total: 0,
        page: 1,
        pageSize: 15
      },
      dataTableCacheName: 'SC-' + this.$route.name + '-data-table',
      columns: [{
        label: '经销商',
        prop: 'name',
        checked: true,
        width: 300
      }, {
        label: '平台代码',
        prop: 'platform_code',
        checked: true,
        width: 300,
        fixedWidth: true,
        slot: 'platform_code'
      }, {
        label: '是否绑定',
        prop: 'platform',
        checked: true,
        width: 300,
        slot: 'platform'
      }],
      initialized: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.dataLoading = false;
                that.dataList = [];
                that.searchForm.page = 1;
                that.searchForm.total = 0;

                if (that.initialized) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return that.loadData();

              case 8:
                that.initialized = true;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;

                if (!that.dataLoading) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                that.dataList = [];
                that.dataLoading = true;
                _context2.next = 7;
                return listCorp(that.searchForm).then(function (res) {
                  that.dataList = res.list;
                  that.searchForm.total = res.total;
                }).catch(function (e) {});

              case 7:
                that.dataLoading = false;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    copyToClipboard: function copyToClipboard(str) {
      var that = this;
      that.$copyText(str).then(function () {
        that.$message.success('复制成功'); // 复制成功的操作
      }, function () {
        console.log('复制失败'); // 复制失败的操作
      });
    },
    searchFormSubmit: function searchFormSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.loadData();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    dataRowDbClick: function dataRowDbClick(row) {
      var that = this;
      that.dataEdit(row);
    },
    dataCreate: function dataCreate() {
      var that = this;
      var row = {
        id: null,
        manuId: that.searchForm.manuId
      };
      that.$refs.FormComponentRef.init(row);
    },
    dataEdit: function dataEdit(row) {
      var that = this;
      that.$refs.FormComponentRef.init(row);
    },
    dataDelete: function dataDelete(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, form, rows;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this3;
                form = {
                  ids: []
                };

                if (row) {
                  form.ids = [row.ID];
                } else {
                  rows = that.$refs.dataTableRef.selections();
                  form.ids = rows.map(function (item) {
                    return item.ID;
                  });
                }

                if (!(form.ids.length === 0)) {
                  _context4.next = 6;
                  break;
                }

                that.$message.error('请选择要删除的数据');
                return _context4.abrupt("return");

              case 6:
                that.$confirm('此操作将删除' + form.ids.length + '条数据, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          _context3.next = 3;
                          return deleteDealerUserAddress(form);

                        case 3:
                          that.loadData();
                          _context3.next = 8;
                          break;

                        case 6:
                          _context3.prev = 6;
                          _context3.t0 = _context3["catch"](0);

                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[0, 6]]);
                }))).catch(function (e) {});

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};